var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"8b28f6179f3f1874299e047cb8a3f323b57630b7"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["homeroom-frontend-prod@joinhomeroom"]={id:"8b28f6179f3f1874299e047cb8a3f323b57630b7"};
      